import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, Redirect, withRouter } from 'react-router-dom';

import { Grid, Button, IconButton, Badge } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

import { WithStyles, createStyles,Checkbox } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';

import PreviewPageInfo from '../components/PreviewPageInfo';
import OtherRelatedContent from '../components/OtherRelatedContent';
import SharedContentWith from '../components/SharedContentWith';
import ContentDeleteConfirm from '../components/ContentDeleteConfirm';
import ContentShareModal from '../components/ContentShareModal';

import StudyMaterialPreview from '../components/ContentPreview/StudyMaterialPreview';
import SampleProblemPreview from '../components/ContentPreview/SampleProblemPreview';
import TestPreview from '../components/ContentPreview/TestPreview';
import MCQPreview from '../components/ContentPreview/MCQPreview';
import ParagraphPreview from '../components/ContentPreview/ParagraphPreview';
import FormulaPreview from '../components/ContentPreview/FormulaPreview';
import VideoPreview from '../components/ContentPreview/VideoPreview';
import AudioPreview from '../components/ContentPreview/AudioPreview';
import NotesPreview from '../components/ContentPreview/NotePreview';
import MatrixPreview from '../components/ContentPreview/MatrixPreview';
import CommentDialog from '../components/ContentPreview/CommentDialog';

import { MyPATLink, ModalComponent, dateService } from '../../common';
import ContentData from '../types/ContentData';
import ContentDataDefault from '../types/ContentDataDefault';
import contentService from '../services/contentService';
import ACL from '../../acl/components/ACL';

import { getCommentCount } from '../actions/commentActions';
import contentActions from '../actions/contentActions';
import { getContentSubTypeCode, getClientId, getPropertyValue, getUserType, checkForTeacherUser, createDeepCopy, checkForAuthor } from '../../../utils';
import { QuestionBenchmarks } from '../types/Benchmarks';
import Benchmark from '../components/Benchmark';
import ChallengeQuestion from '../components/ContentPreview/ChallengeQuestion/index';
import ACLService from '../../acl/services/aclService';
import { toggleLicenseExpiredDialog, setLoggedInUser } from '../../login/actions/userActions';
import { getVariationName } from '../../../utils/getOffset.utils';
import { CONTENT_SECTION_KEYS, CONTENT_TYPE, contentTypesForContentHistoryMap, MODULE_TO_QUESTION_PERMISSION_MAP, MODULE_TO_TEST_PERMISSION_MAP, PERMISSION_CONTENT_TYPES, QUESTION_TYPES, titleCase, USER_TYPE, CONTENT_STATES, USER_RIGHTS, STATUS_CODES, AUTHORING_CONTENT_TYPES } from '../../../constants/comman';
import QuestionAnalytics from '../components/QuestionAnalytics';
import TestAnalytics from '../components/TestAnalytics';
import FeedbackPreview from '../../content-request/components/FeedbackPreview';
import { getFeedback } from '../../content-request/actions/contentRequestActions';
import contentRequestServices from '../../content-request/services/contentRequestServices';
import { contentRequestAccordianActions } from '../../content-request/reducers/contentRequestAccordianState';
import MyPATCollapseSection from '../../common/MyPATCollapseSection';
import MyPATCollapseSectionItem from '../../common/MyPATCollapseSectionItem';
import CustomInfoIcon from '../../common/CustomInfoIcon';
import ContentSuggestions from '../components/ContentSuggestions';
import { showMsg as showAlert, showMsg } from '../../course/actions/loaderAlert';
import { questionActions } from '../reducers/questionCreateReducer';
// import SendNotification from './SendNotification';
import { MyPATDialog, MyPATTextField } from "../../common";
import { FEEDBACK_VALIDATOR_ACTIONS, FOOTER_TEXT, NEW_FEEDBACK_TIME_TO_SHOW, SECTIONS, SIDEBAR_TAB, SUBMIT_MODAL_BODY_TEXT } from '../helper/contentValidation';
import FeedbackSidebar from '../components/ContentCreate/FeedbackSidebar';
import ValidationSubmitModal from '../components/ContentPreview/ValidationSubmitModal';
import ContentValidationEditHistory from '../components/ContentCreate/ContentValidationEditHistory';
import { VARIANT } from '../../common/types/ServerAlertDataV2';
import ValidatorFields from '../components/ContentCreate/ValidatorFields';
import cx from 'classnames'
import { REMEDIAL_KEY } from '../reducers/remedialQuestionReducer';
import PreviewTest from '../components/PreviewTest';
import RateQuestionModal from '../components/ContentRating/RateQuestionModal';
import RejectionReasonModal from '../components/ContentRating/rejectionReasonModal';
import ViewRatingAndReview from '../components/ContentRating/ViewRatingAndReview';
import { contentRatingServices } from '../services/contentRatingService';

const styles = (theme: Theme) =>
  createStyles({
    contentValidationFooter: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '33px 32px',
      backgroundColor: '#ffffff',
      boxShadow: '0 -3px 8px 0 rgba(0, 0, 0, 0.25)',
      position: 'fixed',
      bottom: '0',
      width: '100%',
      right: '0',
      zIndex: 99,
      maxHeight:'102px',
      '& .instruction': {
        width: '882px',
        marginLeft: '90px',
        color: '#666666'
      },
      '& .btnGroupContainer': {
        margin: '0 -8.5px',
        '& .btnBorder': {
          minWidth: '80px',
          padding: '8px 19px',
          border: '1px solid #1D7DEA',
          borderRadius: '4px',
          fontSize: '14px',
          fontWeight: 400,
          fontFamily: 'Nunito',
          lineHeight: '135%',
          color: '#1D7DEA',
          backgroundColor: '#ffffff',
          margin: '0 8.5px',
          cursor: 'pointer',
        },
        '& .btnFill': {
          minWidth: '80px',
          padding: '8px 11px',
          border: '1px solid #1D7DEA',
          borderRadius: '4px',
          fontSize: '14px',
          fontWeight: 400,
          fontFamily: 'Nunito',
          lineHeight: '135%',
          color: '#ffffff',
          backgroundColor: '#1D7DEA',
          margin: '0 8.5px',
          cursor: 'pointer',
          '&[disabled]': {
            opacity: 0.5,
            pointerEvents: 'none',
          },
        },
      },
    },
    activeArrow: {
      background: 'rgb(29 125 234)',
      width: 25,
      height: 25,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '0 5px',
      color: '#fff',
      borderRadius: '50%',
    },
    deactiveArrow: {
      background: 'rgb(29 125 234)',
      opacity: 0.5,
      pointerEvents: 'none',
      width: 25,
      height: 25,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '0 5px',
      color: '#fff',
      borderRadius: '50%',
    },
    feedbackTopNav: {
      // marginTop: 0,
      // paddingTop: 9,
      // paddingBottom: 0,
      // marginBottom: 0,
      // paddingLeft: 90,
      '& .arrow': {
        padding: '0px 3px 2px 2px',
        borderRadius: '50%',
        margin: '0px 4px',
        color: '#fff',
        cursor: 'pointer',
        '&:hover': {
          background: 'rgb(29 125 234)',
        },
      },
      '& .closeButton': {
        color: '#1d7dea',
        cursor: 'pointer',
        verticleAlign: 'middle',
        '& svg': {
          marginBottom: 2,
        },
      },
    },
    backButton: {
      display: 'block',
      lineHeight: theme.spacing.unit + 'px',
      color: theme.palette.text.secondary,
      textDecoration: 'none',
      fontWeight: 'bold',
      '& svg': {
        verticalAlign: 'bottom',
      },
      '&:hover': {
        textDecoration: 'none',
      },
    },
    actionContainer: {
      alignSelf: 'flex-end',
      display: 'flex',
      justifyContent: 'flex-end',
      '& > *': {
        marginLeft: theme.spacing.unit * 2,
        minWidth: '93px',
      },
      '& img': {
        marginRight: 3,
      },
    },
    shareButton: {
      background: theme.palette.common.white,
    },
    blue: {
      border: 'solid 1px #1D7DEA',
      boxSizing: 'border-box',
      color: '#1D7DEA',
      fontWeight: 600,
    },
    copyButton: {
      background: theme.palette.common.white,
      '& .disabled': {
        opacity: 0.3,
      },
    },
    commentButton: {
      minWidth: 'unset',
      padding: theme.spacing.unit + 2,
      '& img': {
        margin: '0 auto',
      },
    },
    sidePanel: {
      paddingRight: '30px !important',
      paddingTop: '30px !important',
      position: 'sticky',
      top: '55px',
      '& .fullButton': {
        width: '100%',
      },
      '& .feedbackAction': {
        boxShadow: 'none',
        background: 'rgb(0 0 0 / 0%)',
        marginBottom: 0,
        padding: '10px 0px 10px',
      },
      '& > *': {
        marginBottom: theme.spacing.unit + 2,
        // boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.12)',
        borderRadius: 4,
      },
      '&': {
        width: '100%',
        height: '100%',
      },
    },
    paddingSet: {
      padding: '0 15px 0 0',
    },
    popupBlock: {
      width: '450px',
      textAlign: 'center',
      '& p': {
        fontSize: '16px',
        'font-weight': 'normal',
        lineHeight: '16px',
        textAlign: 'center',
        letterSpacing: '0.144385px',
        color: '#000000',
        display: 'block',
        paddingTop: '20px',
      },
    },
    attentionTitle: {
      fontSize: '16px',
      'font-weight': '500',
      lineHeight: '15px',
      textAlign: 'center',
      letterSpacing: '0.144385px',
      color: '#000000',
      display: 'block',
      paddingBottom: '18px',
    },
    hide: {
      display: 'none',
    },
    toolBox: {
      position: 'sticky',
      top: 0,
      zIndex: 99,
      minHeight: '60px',
      lienHeight: '60px',
      background: '#FBFBFB',
      padding: theme.spacing.unit + 2,
      borderBottom: '1px solid #eee',
      marginTop: '-15px',
      // width: "calc(100% - 70px)",
      right: 0,
      marginLeft: 'auto',
      '& .jodit_toolbar': {
        width: '99vw !important',
        textAlign: 'center',
      },
      '& .arrow': {
        padding: '0px 3px 2px 2px',
        borderRadius: '50%',
        margin: '0px 4px',
        color: '#fff',
        cursor: 'pointer',
        '&:hover': {
          background: 'rgb(29 125 234)',
        },
      },
      '& .closeButton': {
        color: '#1d7dea',
        cursor: 'pointer',
        verticleAlign: 'middle',
        '& svg': {
          marginBottom: 2,
        },
      },
    },
    footerFixed: {
      position: 'fixed',
      zIndex: 100,
      right: 0,
      width: '100%',
      bottom: 0,
      textAlign: 'right',
      backgroundColor: '#ffffff',
      paddingRight: '26px',
      padding: '15px 24px',
      boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
      // display: 'grid',
      gridTemplateColumns: '92% 8%',
      alignItems: 'center',
      '& button': {
        padding: '10px 15px',
        // maxWidth: 140,
        // width: "100%",
      },
    },
    paddingBot50: {
      paddingBottom: 210,
    },
    displayFlex: {
      display: 'flex',
    },
    confirmationDialog: {
      display: 'block',
    },
    confirmationDialogTitle: {
      margin: '0',
      fontSize: '24px',
      fontWeight: 600,
      lineHeight: '133%',
      color: '#333333',
    },
    confirmationDialogButton: {
      padding: '18px 0',
      '& .btnText': {
        fontSize: '16px',
        fontWeight: 500,
        color: '#1D7DEA',
        padding: '5px 18px',
      },
      '& .btnFill': {
        fontSize: '16px',
        fontWeight: 500,
        color: '#ffffff',
        backgroundColor: '#1D7DEA',
        padding: '5px 18px',
        minWidth: '94px',
        height: '44px',
      },
    },
    confirmationParagraphMargin: {
      margin: 0,
      padding: '6px 0 4px',
      width: '100%',
    },
    confirmationDialogButtonPadding: {
      padding: '0 0 18px',
    },
    confirmationDialogPara: {
      '& p': {
        fontSize: '16px',
        fontWeight: 400,
        fontFamily: 'Nunito',
        lineHeight: '150%',
        color: '#666666',
        margin: 0,
        textAlign: 'center',
        width: '100%',
      },
      '& .declationContent': {
        backgroundColor: 'rgba(246, 250, 244, 0.7)',
        borderRadius: '4px',
        padding: '15px',
        margin: '20px auto',
        '& p': {
          textAlign: 'left',
        },
        '& strong': {
          fontWeight: 700,
        }
      }
    },
    inputCheckbox: {
      display: 'flex',
      margin: '0 auto 20px',
      maxWidth: '460px',
      alignItems:'center',
      '& .checkbox': {
        width: '20px',
        minWidth: '20px',
        height: '20px',
        position: 'relative',
      },
      '& input': {
        width: '100%',
        height: '100%',
        position: 'absolute',
        left: 0,
        top: 0,
        opacity: 0,
        margin: 0,
        color:'blue !important'
      },
      '& .checkboxMark': {
        width: '100%',
        height: '100%',
        border: '1px solid #979797',
        borderRadius: '2px',
        display: 'block',
      },
      '& label': {
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '125%',
        color: '#666666',
        paddingLeft: '8px',
      },
      '& input:checked + .checkboxMark': {
        backgroundImage: 'url(/assets/svg/contentValidation/checkmark-icon.svg)',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        backgroundColor: '#1D7DEA',
        borderColor: '#1D7DEA',
      }
    },
    checkboxChecked: {
      color: '#1D7DEA !important'
    },
    backValidatorButton: {
      fontWeight: 'bold',
      textAlign: 'center',
      '& >svg ': {
        marginBottom: '0 !important'
      }
    },
    previewContainer: {
      boxShadow: '0px 3px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
    },
    editButton: {
      '& button': {
        width: '100%',
      },
      position: 'relative',
      '& .tooltip': {
        display: 'none',
      },
      '&:hover': {
        '& .tooltip': {
          display: 'block',
          position: 'absolute',
          background: 'rgb(222 222 222)',
          width: 'max-content',
          right: 0,
          zIndex: 999,
          top: 43,
          padding: 12,
          color: 'rgb(51 51 51)',
          lineHeight: '20px',
          fontWeight: 600,
          '&::before': {
            right: 55,
            width: 0,
            top: -8,
            height: 0,
            content: '" "',
            position: 'absolute',
            marginLeft: -6,
            borderLeft: '5px solid rgb(0 0 0 / 0%)',
            borderRight: '5px solid rgb(0 0 0 / 0%)',
            borderBottom: '8px solid rgb(222 222 222)',
          },
        },
      },
    }
  });

// @ts-ignore
const createRef = React.createRef
//@ts-ignore
interface ContentPreviewProps extends WithStyles<typeof styles> {
  classes: any;
  match: any;
  getCommentCount: (contentId: string) => void;
  commentCount: number;
  history: any;
  fetchEditLockInfo: Function;
  lockData: any;
  fetchBenchMarkInfo: Function;
  updateBenchMarkInfo: Function;
  fetchGoalLevels: Function;
  authUser: any;
  setRequiresForceSaveForChallenge: (val: boolean) => void;
  userData: any;
  loggedInUserData: any;
  showLicenseExpiredDialog: any;
  isPostExpiryDays: any;
  toggleLicenseExpiredDialog: any;
  setLoggedInUser: any;
  fromFeedback: boolean;
  prevPath?: string;
  contentRequestId: string;
  sliderData?: any;
  onContentChange?: Function;
  closeReviewContainer?: Function;
  currentQuestionNumber?: number;
  currentTestNumber: number;
  getFeedback: Function;
  feedBackData: any;
  authorType: string;
  refreshFeedback: boolean;
  handleEditFromFeedback: Function;
  fromURL?: string;
  setFeedbackClose: Function;
  suggestions:{similarContents:any [],duplicateContents:any []},
  setContentSuggestions:(params:{type:string,id:string})=>void,
  showAlert:any;
  setSpecialPurposes: Function;
  showMsg: Function;
  validatorFields: boolean;
  setValidatorFields: Function
}

interface ContentPreviewStates {
  content: ContentData;
  noteData: any;
  isDeleteDialogOpen: boolean;
  isShareDialogOpen: boolean;
  isCommentDialogOpen: boolean;
  latexLoad: Boolean;
  isOpen: boolean;
  lockData: any;
  contentHistory: any[];
  questionBenchmarks: {
    [questionId: string]: QuestionBenchmarks;
  };
  isOpenBenchmarkDialog: boolean;
  localIsPostExpiryDays: boolean;
  questionAnalytics: any;
  testAnalytics: any;
  contentRequestIds: any;
  openFeedback: boolean;
  clickedfeedbackData: any;
  showAssignTest: boolean;
  activeValidationFeedbackSection: string,
  activeValidationFeedbackIndex: number,
  activeValidationFeedbackData: any,
  validationFeedbacks: any,
  existingValidationFeedbackIds: any[],
  addedFeedbackIndex: number,
  validationEditHistory: any,
  newFeedbacks: any,
  confirmationDialogType: string,
  allowFeedbacks: boolean,
  enableValidationConfirm: boolean,
  validationStatus: string,
  validatorNumber: null|number,
  validationSubmitModalBody: string,
  currentSelectedQuestionRef: any;
  submitValidatorRef: any;
  validatorMandatoryFields: any;
  studentContent: any;
  studentInfo: any;
  removeFeedbackForAuthor: any;
  contentValidationFeedback: any[],
  activeFeedbackSection: string,
  remedialQuestions: any[],
  paragraphRemedialQuestion: any
  testId: string;
  isRateQuestionModalOpen: boolean;
  isRejectionReasonModalOpen: boolean;
  questionRejectionReasons: any[];
  isViewRatingAndReviewOpen: boolean;
  validtorActionType: string;
  contentRatingInfo: any;
  isValidatorRating: boolean;
  showEditHistory: boolean;
}
const DEFAULT_QUESTION_BENCHMARK: QuestionBenchmarks = {
  hasBenchmarks: false,
  benchmarks: [],
};

class ContentPreview extends Component<ContentPreviewProps, ContentPreviewStates> {
  constructor(props: ContentPreviewProps) {
    super(props);
    this.state = {
      content: ContentDataDefault,
      noteData: {},
      isDeleteDialogOpen: false,
      isShareDialogOpen: false,
      isCommentDialogOpen: false,
      latexLoad: false,
      isOpen: false,
      lockData: {},
      contentHistory: [],
      questionBenchmarks: {},
      isOpenBenchmarkDialog: false,
      localIsPostExpiryDays: false,
      questionAnalytics: null,
      testAnalytics: null,
      contentRequestIds: {
        requestIds: [],
      },
      openFeedback: false,
      clickedfeedbackData: {},
      showAssignTest: true,
      activeValidationFeedbackSection: '',
      existingValidationFeedbackIds: [],
      addedFeedbackIndex: -1,
      activeValidationFeedbackIndex: -1,
      activeValidationFeedbackData: {},
      validationFeedbacks: [],
      contentValidationFeedback: [],
      validationEditHistory: [],
      newFeedbacks: [],
      confirmationDialogType: '',
      allowFeedbacks: false,
      enableValidationConfirm: false,
      validationStatus: '',
      validatorNumber: null,
      validationSubmitModalBody: '',
      currentSelectedQuestionRef: createRef(),
      submitValidatorRef: createRef(),
      validatorMandatoryFields: false,
      studentContent: false,
      studentInfo: {},
      removeFeedbackForAuthor: false,
      activeFeedbackSection:'',
      remedialQuestions: [],
      paragraphRemedialQuestion: {},
      testId: '',
      isRateQuestionModalOpen: false,
      isRejectionReasonModalOpen: false,
      isViewRatingAndReviewOpen: false,
      validtorActionType: '',
      questionRejectionReasons: [],
      contentRatingInfo: {},
      isValidatorRating: false,
      showEditHistory: true,
    };

    this.previewComponent = this.previewComponent.bind(this);
    this.deleteContent = this.deleteContent.bind(this);
    this.onDeleteConfirmed = this.onDeleteConfirmed.bind(this);
    this.createClone = this.createClone.bind(this);
    this.onShared = this.onShared.bind(this);
    this.shareClick = this.shareClick.bind(this);
    this.reloadContent = this.reloadContent.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleFeedbackClick = this.handleFeedbackClick.bind(this);
    this.closeFeedback = this.closeFeedback.bind(this);
    this.emptyClickedData = this.emptyClickedData.bind(this);
    this.handleFeedbackEdit = this.handleFeedbackEdit.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.submitForVerify = this.submitForVerify.bind(this);
    this.loadMoreFeedback = this.loadMoreFeedback.bind(this);
  }

  isFromContentRequest = () => {
    return this.props.fromFeedback || _.get(this.props.match, 'params.requestId');
  }

  fetchBenchmarkByQuestionId(id: string) {
    contentService.getBenchmarks({ type: 'question', typeId: id }).then((benchmarksData: QuestionBenchmarks) => {
      this.setState((prevState) => {
        return {
          ...prevState,
          questionBenchmarks: { ...prevState.questionBenchmarks, [id]: benchmarksData },
        };
      });
    });
  }

  fetchRemedialQuestionById(id: string): Promise<any[]> {
    return contentService.getRemedialQuestion(id).then((res: any) => {
      const { remedialQuestions = [] } = res.responseObject || {};
      return remedialQuestions;
    });
  }

  componentDidMount() {
    const { id, type } = this.props.match.params;
    const { fetchBenchMarkInfo } = this.props;
    const userData = JSON.parse(localStorage.getItem('patmy') || '');
    const isTeacher = checkForTeacherUser(null, true);
    contentRequestServices.getContentRequestIds(id.substring(0, 24)).then(
      (res: any) => {
        const { requestIds = [] } = res;
        this.setState({
          contentRequestIds: { ...res },
        });
      });
    contentService.details(id).then((c) => {
      if (!_.isEmpty(c)) {
        this.setState({ content: c });
        this.setState({ testId: c.content_Id });
        if (c.contentTypeCode === AUTHORING_CONTENT_TYPES.GLORIFIRE_QUESTION) {
          this.getContentRatingInfo(c.content_Id);
        }
        const creatorId = _.get(c, 'content.aclMetaData.createdBy.id');
        const {authUser} = this.props;
        const isCreatedByLoggedInUser = creatorId && authUser && creatorId === authUser._id;
        if (isCreatedByLoggedInUser && [c.status, c.validationStatus].includes(FEEDBACK_VALIDATOR_ACTIONS.REJECTED)) {
          this.handleEdit();
          return;
        }
        this.props.setSpecialPurposes(_.get(c, 'specialPurposes', []))
        let id = _.get(c, 'content._id', '');
        if (this.isFromContentRequest()) {
          this.props.getFeedback(this.getContentRequestId(), id, 1);
        }
        this.props.getCommentCount(id);
        if (id && c.contentTypeCode === 'question') {
          if (c.contentSubTypeCode === QUESTION_TYPES.PARAGRAPH.toString()) {
            let resultIds = c.content.content.map((data: any) => data.paragraphQuestionId);
            resultIds = resultIds.join(',');
            if (this.isFromContentRequest()) {
              this.props.getFeedback(this.getContentRequestId(), resultIds, 1);
            }
            // if paragraph type question then fetch benchmarks of all passageData
            c && c.passageData && c.passageData.forEach(({ id }: { id: string }) => this.fetchBenchmarkByQuestionId(id));
          } else {
            this.fetchBenchmarkByQuestionId(id);
          }
        }
        contentService
          .getContentHistory(
            c.content_Id,
            //@ts-ignore
            contentTypesForContentHistoryMap[c.contentTypeCode]
          )
          .then((res: any) => {
            this.setState({ contentHistory: res });
          });

        if (!(c.contentTypeCode === 'studymaterial')) {
          fetchBenchMarkInfo({
            params: { type: 'test', typeId: c.content_Id },
          });
        }
        let courseTypeId:string =  c.content &&
          c.content.courseId &&
          c.content.courseId[0] &&
          c.content.courseId[0].courseType &&
          c.content.courseId[0].courseType.id;
        if (courseTypeId) {
          this.props.fetchGoalLevels({ params: { courseTypeId } });
        }
        if (c.contentTypeCode !== 'testpapers' && c.content) {
          this.props.setContentSuggestions({id:c.content._id,type:c.contentTypeCode==='studymaterial'?c.contentSubTypeCode:c.contentTypeCode});
        }   
        if (c.contentTypeCode == 'question') {
          contentService.getQuestionAnalytics(id).then((res: any) => {
            /* TODO: remove later */
            // const resObj = {
            //   "statusCode": 200,
            //   "responseMessage": "Question analytics retrieved successfully",
            //   "responseObject": {
            //     "analyticsData": [
            //       {
            //         "testId": "5b3225deabc2d869fb909a8f",
            //         "testAttemptCount": 2308,
            //         "attemptPercentage": 56.36915077989602,
            //         "correctPercentage": 11.135181975736568,
            //         "avgTimeToSolve": 16.015093043492474,
            //         "contentId": "T-3319"
            //       },
            //       {
            //         "testId": "5b3225deabc2d869qwfb909a8f",
            //         "testAttemptCount": 5660,
            //         "attemptPercentage": 90.36915077989602,
            //         "correctPercentage": 80.135181975736568,
            //         "avgTimeToSolve": 67.015093043492474,
            //         "contentId": "T-3323"
            //       }
            //     ]
            //   }
            // }
            const parseData = (res: any) => ({ data: res.responseObject, message: res.responseMessage });
            this.setState({ questionAnalytics: parseData(res) });
          });
          if (getPropertyValue(c, 'content.questionCode') === QUESTION_TYPES.PARAGRAPH) {
            const contentArray = getPropertyValue(c, 'content.content', []);
            const paragraphQuestionIds = contentArray.map((item: any) => item.paragraphQuestionId);
            Promise.all(paragraphQuestionIds.map((id: string) => this.fetchRemedialQuestionById(id)))
              .then(results => {
                const indexedRemedialQuestions: any = {};
                results.forEach((remedialQuestions, index) => {
                  indexedRemedialQuestions[`${REMEDIAL_KEY.REMEDIAL}${index + 1}`] = remedialQuestions;
                });
                this.setState({ paragraphRemedialQuestion: indexedRemedialQuestions });
              })
          } else {
            this.fetchRemedialQuestionById(id)
              .then(remedialQuestions => {
                this.setState({ remedialQuestions: remedialQuestions });
              })
          }
        } else if (c.contentTypeCode == 'testpapers') {
          contentService.getTestAnalytics(id).then((res: any) => {
            /* TODO: remove later */
            // const resObj = {
            //   "statusCode": 200,
            //   "responseMessage": "Test analytics retrieved successfully",
            //   "responseObject": {
            //     "analyticsData": {
            //       "hasAnalytics": true,
            //       "totalAttempts": 2,
            //       "finishedAttemptCount": 2,
            //       "ongoingAttemptCount": 0,
            //       "avgTimeTakenInSeconds": 2744.5,
            //       "avgAttemptRate": 39.06,
            //       "avgAccuracyRate": 87.5
            //     }
            //   }
            // }
            const parseData = (res: any) => ({ data: res.responseObject, message: res.responseMessage });
            this.setState({ testAnalytics: parseData(res) });
          });
        }

        setTimeout(() => {
          this.setState({ latexLoad: true });
        }, 200);

        this.props.setLoggedInUser();
        this.checkLocalStorgeForPostExpiryDays();
        if (isTeacher) {
          contentRequestServices.getValidationData({contentId: id.substring(0, 24)}).then((res: any) => {
            const { feedbacks = [], editHistory = [], validatorNumber = 0, status = '', finalAction = '', authorName = '', authorBatches = [], showEditHistory = true} = res || {};
            const existingIds = feedbacks.map((feedback: any) => feedback._id);
            this.setState({
              validationFeedbacks: feedbacks,
              existingValidationFeedbackIds: existingIds,
              validationStatus: status || finalAction,
              validatorNumber: validatorNumber || null,
              validationEditHistory: editHistory,
              studentContent: authorName || getPropertyValue(authorBatches,'length'),
              studentInfo: { authorName, authorBatches },
              contentValidationFeedback: createDeepCopy(feedbacks),
              showEditHistory,
            });
            const contentValidationStatus: any = c.validationStatus;
            if ([FEEDBACK_VALIDATOR_ACTIONS.IN_REVIEW, FEEDBACK_VALIDATOR_ACTIONS.REVIEW_POOL].includes(contentValidationStatus) && (editHistory || []).length) {
              this.setState({ activeFeedbackSection: SIDEBAR_TAB.EDIT_HISTORY });
            }
            if((feedbacks || []).length) {
              this.setState({ activeFeedbackSection: SIDEBAR_TAB.FEEDBACK });
            }
          })
          }
      }
    });
  }

  componentWillReceiveProps(nextProps: any, prevProps: any) {
    const { history } = this.props;
    const { content } = this.state;
    if (nextProps.lockData !== this.props.lockData) {
      if (nextProps.lockData.isLock) {
        this.setState({ isOpen: true });
      } else {
        history.push(contentService.editLink(content, { vKey: getVariationName(this.props.history) }));
      }
    }
  }
  componentDidUpdate(prevProps: any) {
    if (prevProps.refreshFeedback !== this.props.refreshFeedback) {
      if (this.isFromContentRequest()) {
        if (this.state.content.content.questionType !== 'Paragraph') {
          this.props.getFeedback(this.getContentRequestId(), this.state.content.content._id, 1);
        } else if (this.state.content.content.questionType === 'Paragraph') {
          let resultIds = this.state.content.content.content.map((data: any) => data.paragraphQuestionId);
          resultIds = resultIds.join(',');
          if (this.isFromContentRequest()) {
            this.props.getFeedback(this.getContentRequestId(), resultIds, 1);
          }
        } else {
          this.props.getFeedback(this.getContentRequestId(), this.state.content.content._id, 1);
        }
      }
    }
    if (prevProps.match !== this.props.match) {
      if (this.props.fromURL === 'preview') {
        const { id } = this.props.match.params;
        contentService.details(id).then((c) => {
          if (!_.isEmpty(c)) {
            this.setState({ content: c });
            let id = _.get(c, 'content._id', '');
            if (this.isFromContentRequest()) {
              this.props.getFeedback(this.getContentRequestId(), id, 1);
            }
            this.props.getCommentCount(id);
            if (id && c.contentTypeCode === 'question') {
              if (c.contentSubTypeCode === QUESTION_TYPES.PARAGRAPH.toString()) {
                let resultIds = c.content.content.map((data: any) => data.paragraphQuestionId);
                resultIds = resultIds.join(',');
                if (this.isFromContentRequest()) {
                  this.props.getFeedback(this.getContentRequestId(), resultIds, 1);
                }
                // if paragraph type question then fetch benchmarks of all passageData
               c && c.passageData && c.passageData.forEach(({ id }: { id: string }) => this.fetchBenchmarkByQuestionId(id));
              } else {
                this.fetchBenchmarkByQuestionId(id);
              }
            }
            contentService
              .getContentHistory(
                c.content_Id,
                //@ts-ignore
                contentTypesForContentHistoryMap[c.contentTypeCode]
              )
              .then((res: any) => {
                this.setState({ contentHistory: res });
              });

            let courseTypeId =
              c.content.courseId &&
              c.content.courseId[0] &&
              c.content.courseId[0].courseType &&
              c.content.courseId[0].courseType.id;
            if (courseTypeId) {
              this.props.fetchGoalLevels({ params: { courseTypeId } });
            }

            if (c.contentTypeCode == 'question') {
              contentService.getQuestionAnalytics(id).then((res: any) => {
                const parseData = (res: any) => ({ data: res.responseObject, message: res.responseMessage });
                this.setState({ questionAnalytics: parseData(res) });
              });
            } else if (c.contentTypeCode == 'testpapers') {
              contentService.getTestAnalytics(id).then((res: any) => {
                const parseData = (res: any) => ({ data: res.responseObject, message: res.responseMessage });
                this.setState({ testAnalytics: parseData(res) });
              });
            }
            setTimeout(() => {
              this.setState({ latexLoad: true });
            }, 200);
            this.props.setLoggedInUser();
            this.checkLocalStorgeForPostExpiryDays();
          }
        });
      }
    }
  }

  getContentRatingInfo = (masterId: string) => {
    contentRatingServices.getContentRatingInfo(masterId).then((res: any) => {
      this.setState({ contentRatingInfo: res.responseObject});
    })
  }

  toggleCancelButtonForFeedback = () => {
    this.setState({ removeFeedbackForAuthor: !this.state.removeFeedbackForAuthor, activeFeedbackSection: '' });
  }

  addDays(date: any, days: any) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }
  handleFeedback() {
    let clickedfeedbackData =
      this.props.feedBackData &&
      this.props.feedBackData.feedbacksData.filter(
        (feedback: any) => feedback.tag === 'question' && !feedback.isResolved
      );
    if (clickedfeedbackData && clickedfeedbackData.length > 0) {
      this.setState({
        clickedfeedbackData: clickedfeedbackData[0],
      });
    }

    this.setState(
      {
        openFeedback: true,
      },
      () => {
        setTimeout(() => {
          if (document.getElementById('feedbackScroll') !== null) {
            // @ts-ignore
            document.getElementById('feedbackScroll').scrollIntoView(true);
          }
        }, 200);
      }
    );
  }

  closeFeedback(status: string) {
    this.setState({
      openFeedback: false,
    });
    if (status === 'resolve') {
      this.setState({
        clickedfeedbackData: {},
      });
    }
  }

  emptyClickedData() {
    this.setState({
      clickedfeedbackData: {},
    });
  }

  compare_dates(today: Date, endDate: Date, endDatePlusPostExpiry: Date) {
    const todayDay = today.getDate();
    const todayMonth = today.getMonth() + 1;
    const todayYear = today.getFullYear();

    const endDateDay = endDate.getDate();
    const endDateMonth = endDate.getMonth() + 1;
    const endDateYear = endDate.getFullYear();

    const endDatePlusPostExpiryDay = endDatePlusPostExpiry.getDate();
    const endDatePlusPostExpiryMonth = endDatePlusPostExpiry.getMonth() + 1;
    const endDatePlusPostExpiryYear = endDatePlusPostExpiry.getFullYear();

    const checkWithEndDate = today.getTime() > endDate.getTime() ? true : false;
    //Check if today is greater than end date
    // if(todayYear > endDateYear ||
    //   todayMonth > endDateMonth ||
    //   todayDay > endDateDay){
    //     checkWithEndDate = true;
    //   } else {
    //     checkWithEndDate = false;
    //   }

    //Check if today is less than endate plus post expiry days
    let checkWithEndOfGrace;
    if (
      todayYear <= endDatePlusPostExpiryYear ||
      todayMonth <= endDatePlusPostExpiryMonth ||
      todayDay <= endDatePlusPostExpiryDay
    ) {
      checkWithEndOfGrace = true;
    } else {
      checkWithEndOfGrace = false;
    }

    return { checkWithEndDate, checkWithEndOfGrace };
  }

  checkLocalStorgeForPostExpiryDays() {
    let userData: any = localStorage.getItem('patmy');
    let userLicenseData;
    if (userData) {
      userData = JSON.parse(userData);
      userLicenseData = userData.authenticatedUser.clientId.license;
    }

    let today = new Date();
    let endDate = new Date(userLicenseData.endDate);
    let endOfGracePeriodDate = this.addDays(userLicenseData.endDate, userLicenseData.postExpiryAccessibilityDays);

    const { checkWithEndDate, checkWithEndOfGrace } = this.compare_dates(today, endDate, endOfGracePeriodDate);

    if (userLicenseData && userLicenseData.postExpiryAccessibilityDays && checkWithEndDate && checkWithEndOfGrace) {
      this.setState({
        ...this.state,
        localIsPostExpiryDays: true,
      });
    } else {
    }
  }

  reloadContent() {
    const { id } = this.props.match.params;
    contentService.detailsNTL(id).then((c) => {
      this.setState({ content: c });
    });
  }

  deleteContent() {
    this.setState({ isDeleteDialogOpen: true });
  }

  onDeleteConfirmed(action: boolean) {
    const { content } = this.state;
    this.setState({ isDeleteDialogOpen: false });
    if (action == true) {
      this.reloadContent();
    }
  }

  createClone() {
    if (this.state.localIsPostExpiryDays) {
      this.props.toggleLicenseExpiredDialog(true);
    } else {
      let that = this;
      let redirectUrl: string = window.location.origin;
      let contentLink: any = contentService.editLink(this.state.content);
      contentLink = contentLink.split('/');
      contentLink.pop();
      contentService.clone(this.state.content._id).then(function(data) {
        if (data.type === 'studymaterial') {
          redirectUrl = redirectUrl + contentLink.join('/') + '/' + data._id + 'note';
        } else {
          redirectUrl = redirectUrl + contentLink.join('/') + '/' + ((data || {})._id || '') + ((data || {}).type || '');
        }
        (data._id && data.type) && (window.location.href = redirectUrl);
      });
    }
  }

  onShared(shared: boolean) {
    this.setState({ isShareDialogOpen: false });
    if (shared) {
      setTimeout(() => { this.reloadContent(); }, 1500)
      
    }
  }

  shareClick() {
    if (this.state.localIsPostExpiryDays) {
      this.props.toggleLicenseExpiredDialog(true);
    } else {
      this.setState({ isShareDialogOpen: true });
    }
  }

  checkContentRequest = () => {
    let user = this.props.userData.authenticatedUser;
    const content = this.state.content || ContentDataDefault;

    let createdBy =
    content &&
    content.aclMetaData &&
    content.aclMetaData.createdBy &&
    content.aclMetaData.createdBy.email === user.email;

    const {params: {
      requestId = '',
    }} = this.props.match;
    return requestId ? false :  (_.get(this.state.contentRequestIds, 'requestIds', []).length > 0 && !createdBy);
  }

  isContentInDraft = () => {
    const content = this.state.content || ContentDataDefault;
    const draftData = content.draftData;
    return !!Object.keys(draftData || {}).length && [FEEDBACK_VALIDATOR_ACTIONS.REVIEW_POOL, FEEDBACK_VALIDATOR_ACTIONS.REJECTED, FEEDBACK_VALIDATOR_ACTIONS.IN_REVIEW, FEEDBACK_VALIDATOR_ACTIONS.QUEUED].includes(draftData.validationStatus);
  }

  isDuplicationPermitted(content:any = null){
    let module = content;
    if(module === 'testpapers'){
      module = 'test';
    }
    else if(module === 'studymaterial' || module === 'formulas'){
      module = 'studyMaterial';
    }
    return ACLService.checkModulePermission(module, 'create') || ACLService.checkModulePermission(module, 'edit');
  }

  checkEditPermission() {
    const content = this.state.content || ContentDataDefault;
    let module = content.contentTypeCode === 'testpapers' ? 'test' : 'question';
    module = content.contentTypeCode === 'studymaterial' ? 'studyMaterial' : module;
    if ([PERMISSION_CONTENT_TYPES.GLORIFIRE_QUESTION, PERMISSION_CONTENT_TYPES.GLORIFIRE_TESTPAPERS].includes(module)) {
      let permissionType = (content.specialPurposes && content.specialPurposes[0]) || CONTENT_SECTION_KEYS.GLORIFIRE;
      module = (module === PERMISSION_CONTENT_TYPES.GLORIFIRE_QUESTION) ? MODULE_TO_QUESTION_PERMISSION_MAP[permissionType] : MODULE_TO_TEST_PERMISSION_MAP[permissionType];
    }
    let user = this.props.userData.authenticatedUser;
    let createPermission =
      user &&
      user.role &&
      user.role.permissions &&
      user.role.permissions.filter(function(val: any) {
        if (val.module === module) {
          return val.access.includes('create');
        }
      }).length;
    let createdBy =
      content &&
      content.aclMetaData &&
      content.aclMetaData.createdBy &&
      content.aclMetaData.createdBy.email === user.email;
    let digitizedBy = getPropertyValue(content, 'aclMetaData.digitizedBy.email') === user.email;
    if ((createdBy || digitizedBy) && createPermission) return true;
    let editPermission =
      user &&
      user.role &&
      user.role.permissions &&
      user.role.permissions.filter(function(val: any) {
        if (val.module === module) {
          return val.access.includes('edit');
        }
      }).length;
    if (editPermission) return true;
    const clientwiseEditPermission = ACLService.checkModulePermission(module, USER_RIGHTS.EDIT_CLIENT_WISE);
    const sameClientContent = getPropertyValue(content, 'aclMetaData.clientId') === getPropertyValue(user, 'clientId._id');
    return clientwiseEditPermission && sameClientContent;
  }
  getContentRequestId = () => {
    if(this.props.contentRequestId) {
      return this.props.contentRequestId;
    }
    const query = new URLSearchParams(this.props.history.location.search);
    return query.get("contentRequestId")
  }
  getContentRequestItemsId = () => {
    const query = new URLSearchParams(this.props.history.location.search);
    const contentRequestItemsId = query.get("contentRequestItemsId");
    if(contentRequestItemsId) {
      return contentRequestItemsId
    }
    return _.get(this.props.sliderData, '_id') 
  }
  getAuthorType = () => {
    const query = new URLSearchParams(this.props.history.location.search);
    return query.get("authorType") || this.props.authorType;
  }
  previewComponent = (): any => {
    const { id } = this.props.match.params;
    const content = this.state.content || ContentDataDefault;
    const { questionBenchmarks, openFeedback, clickedfeedbackData } = this.state;
    const { contentRequestId, sliderData } = this.props;
    let benchmarksData: any;
    if (content.contentTypeCode === 'question') {
      if (content.contentSubTypeCode === QUESTION_TYPES.PARAGRAPH.toString()) {
        const passageDataIds = content && content.passageData && content.passageData.map(({ id }: { id: string }) => id);
        benchmarksData = _.pick(questionBenchmarks, passageDataIds);
      } else {
        const questionId = content.content_Id;
        benchmarksData = content.masterVariationQuestionId
          ? DEFAULT_QUESTION_BENCHMARK
          : questionId
          ? questionBenchmarks[questionId]
          : DEFAULT_QUESTION_BENCHMARK;
      }
    }
    switch (content.contentTypeCode) {
      case 'testpapers': {
        return (
          <TestPreview
            content={content}
            openFeedback={openFeedback}
            authorType={this.getAuthorType()}
            contentRequestId={this.getContentRequestId()}
            contentRequestItemId={this.getContentRequestItemsId()}
            clickedfeedbackData={clickedfeedbackData}
            closeFeedback={this.closeFeedback}
            emptyClickedData={this.emptyClickedData}
            handleFeedbackResolve={this.handleFeedbackClick}
            feedbackData={this.props.feedBackData}
            fromFeedback={this.isFromContentRequest()}
          />
        );
      }

      case 'studymaterial': {
        switch (getContentSubTypeCode(content.contentSubTypeCode)) {
          case 'videos':
            return <VideoPreview content={content} />;
          case 'audios':
            return <AudioPreview content={content} />;
          case 'note': {
            return <NotesPreview content={content} />;
          }
          default:
            return <StudyMaterialPreview content={content} />;
        }
      }
      case 'note': {
        return <NotesPreview content={content} />;
      }

      case 'sampleproblem': {
        return <SampleProblemPreview content={content} />;
      }

      case 'formulas': {
        return <FormulaPreview content={content} />;
      }

      case 'audios': {
        return <AudioPreview content={content} />;
      }

      case 'videos': {
        return <VideoPreview content={content} />;
      }

      case 'question': {
        let contentSubTypeCode = content.contentSubTypeCode;
        if (content.masterVariationQuestionId) {
          contentSubTypeCode = content.masterVariationQuestionData.passageId
            ? '5'
            : _.get(content.masterVariationQuestionData, 'questionCode', '');
        }
        switch (getContentSubTypeCode(contentSubTypeCode)) {
          case '0': {
            //SMCQ

            return (
              <MCQPreview
                questionBenchmarks={benchmarksData}
                content={content}
                openFeedback={openFeedback}
                authorType={this.getAuthorType()}
                contentRequestId={this.getContentRequestId()}
                contentRequestItemId={this.getContentRequestItemsId()}
                clickedfeedbackData={clickedfeedbackData}
                closeFeedback={this.closeFeedback}
                emptyClickedData={this.emptyClickedData}
                handleFeedbackResolve={this.handleFeedbackClick}
                feedbackData={this.props.feedBackData}
                createNewValidationFeedback={this.createNewValidationFeedback.bind(this)}
                activeValidationFeedbackSection={this.state.activeValidationFeedbackSection}
                activeValidationFeedbackData={this.state.activeValidationFeedbackData}
                handleAddCommentInFeedback={this.handleAddCommentInFeedback.bind(this)}
                allowFeedbacks={this.state.allowFeedbacks}
                studentInfo={this.state.studentInfo}
                remedialQuestion = {this.state.remedialQuestions}
                showRemedial={true}
                toggleViewRating={this.toggleViewRating.bind(this)}
                contentRatingInfo={this.state.contentRatingInfo}
                handleRateQuestionOpen={this.handleRateQuestionOpen.bind(this)}
              />
            );
          }
          case '1': {
            //Matrix
            return (
              <MatrixPreview
                questionBenchmarks={benchmarksData}
                content={content}
                openFeedback={openFeedback}
                authorType={this.getAuthorType()}
                contentRequestId={this.getContentRequestId()}
                contentRequestItemId={this.getContentRequestItemsId()}
                clickedfeedbackData={clickedfeedbackData}
                closeFeedback={this.closeFeedback}
                emptyClickedData={this.emptyClickedData}
                handleFeedbackResolve={this.handleFeedbackClick}
                feedbackData={this.props.feedBackData}
                createNewValidationFeedback={this.createNewValidationFeedback.bind(this)}
                activeValidationFeedbackSection={this.state.activeValidationFeedbackSection}
                activeValidationFeedbackData={this.state.activeValidationFeedbackData}
                handleAddCommentInFeedback={this.handleAddCommentInFeedback.bind(this)}
                allowFeedbacks={this.state.allowFeedbacks}
                studentInfo={this.state.studentInfo}
                remedialQuestion = {this.state.remedialQuestions}
                showRemedial={true}
                toggleViewRating={this.toggleViewRating.bind(this)}
                contentRatingInfo={this.state.contentRatingInfo}
                handleRateQuestionOpen={this.handleRateQuestionOpen.bind(this)}
              />
            );
          }
          case '2': {
            //true/false
            return (
              <MCQPreview
                questionBenchmarks={benchmarksData}
                content={content}
                openFeedback={openFeedback}
                authorType={this.getAuthorType()}
                contentRequestId={this.getContentRequestId()}
                contentRequestItemId={this.getContentRequestItemsId()}
                clickedfeedbackData={clickedfeedbackData}
                closeFeedback={this.closeFeedback}
                emptyClickedData={this.emptyClickedData}
                handleFeedbackResolve={this.handleFeedbackClick}
                feedbackData={this.props.feedBackData}
                createNewValidationFeedback={this.createNewValidationFeedback.bind(this)}
                activeValidationFeedbackSection={this.state.activeValidationFeedbackSection}
                activeValidationFeedbackData={this.state.activeValidationFeedbackData}
                handleAddCommentInFeedback={this.handleAddCommentInFeedback.bind(this)}
                allowFeedbacks={this.state.allowFeedbacks}
                studentInfo={this.state.studentInfo}
                remedialQuestion = {this.state.remedialQuestions}
                showRemedial={true}
                toggleViewRating={this.toggleViewRating.bind(this)}
                contentRatingInfo={this.state.contentRatingInfo}
                handleRateQuestionOpen={this.handleRateQuestionOpen.bind(this)}
              />
            );
          }
          case '3': {
            //blank
            return (
              <MCQPreview
                questionBenchmarks={benchmarksData}
                content={content}
                openFeedback={openFeedback}
                authorType={this.getAuthorType()}
                contentRequestId={this.getContentRequestId()}
                contentRequestItemId={this.getContentRequestItemsId()}
                clickedfeedbackData={clickedfeedbackData}
                closeFeedback={this.closeFeedback}
                emptyClickedData={this.emptyClickedData}
                handleFeedbackResolve={this.handleFeedbackClick}
                feedbackData={this.props.feedBackData}
                createNewValidationFeedback={this.createNewValidationFeedback.bind(this)}
                activeValidationFeedbackSection={this.state.activeValidationFeedbackSection}
                activeValidationFeedbackData={this.state.activeValidationFeedbackData}
                handleAddCommentInFeedback={this.handleAddCommentInFeedback.bind(this)}
                allowFeedbacks={this.state.allowFeedbacks}
                studentInfo={this.state.studentInfo}
                remedialQuestion = {this.state.remedialQuestions}
                showRemedial={true}
                toggleViewRating={this.toggleViewRating.bind(this)}
                contentRatingInfo={this.state.contentRatingInfo}
                handleRateQuestionOpen={this.handleRateQuestionOpen.bind(this)}
              />
            );
          }
          case '4': {
            //descriptive
            return (
              <MCQPreview
                questionBenchmarks={benchmarksData}
                content={content}
                openFeedback={openFeedback}
                authorType={this.getAuthorType()}
                contentRequestId={this.getContentRequestId()}
                contentRequestItemId={this.getContentRequestItemsId()}
                clickedfeedbackData={clickedfeedbackData}
                closeFeedback={this.closeFeedback}
                emptyClickedData={this.emptyClickedData}
                handleFeedbackResolve={this.handleFeedbackClick}
                feedbackData={this.props.feedBackData}
                createNewValidationFeedback={this.createNewValidationFeedback.bind(this)}
                activeValidationFeedbackSection={this.state.activeValidationFeedbackSection}
                activeValidationFeedbackData={this.state.activeValidationFeedbackData}
                handleAddCommentInFeedback={this.handleAddCommentInFeedback.bind(this)}
                allowFeedbacks={this.state.allowFeedbacks}
                studentInfo={this.state.studentInfo}
                remedialQuestion = {this.state.remedialQuestions}
                showRemedial={true}
                toggleViewRating={this.toggleViewRating.bind(this)}
                contentRatingInfo={this.state.contentRatingInfo}
                handleRateQuestionOpen={this.handleRateQuestionOpen.bind(this)}
              />
            );
          }
          case '5': {
            //Paragraph
            return (
              <ParagraphPreview
                questionBenchmarks={benchmarksData}
                content={content}
                openFeedback={openFeedback}
                authorType={this.getAuthorType()}
                contentRequestId={this.getContentRequestId()}
                contentRequestItemId={this.getContentRequestItemsId()}
                clickedfeedbackData={clickedfeedbackData}
                closeFeedback={this.closeFeedback}
                emptyClickedData={this.emptyClickedData}
                handleFeedbackResolve={this.handleFeedbackClick}
                feedbackData={this.props.feedBackData}
                createNewValidationFeedback={this.createNewValidationFeedback.bind(this)}
                activeValidationFeedbackSection={this.state.activeValidationFeedbackSection}
                activeValidationFeedbackData={this.state.activeValidationFeedbackData}
                handleAddCommentInFeedback={this.handleAddCommentInFeedback.bind(this)}
                allowFeedbacks={this.state.allowFeedbacks}
                selectedQuestionRef={this.state.currentSelectedQuestionRef}
                studentInfo={this.state.studentInfo}
                remedialQuestion = {this.state.paragraphRemedialQuestion}
                showRemedial={true}
                toggleViewRating={this.toggleViewRating.bind(this)}
                contentRatingInfo={this.state.contentRatingInfo}
                handleRateQuestionOpen={this.handleRateQuestionOpen.bind(this)}
              />
            );
          }
          case '6': {
            //Numerical
            return (
              <MCQPreview
                questionBenchmarks={benchmarksData}
                content={content}
                openFeedback={openFeedback}
                authorType={this.getAuthorType()}
                contentRequestId={this.getContentRequestId()}
                contentRequestItemId={this.getContentRequestItemsId()}
                clickedfeedbackData={clickedfeedbackData}
                closeFeedback={this.closeFeedback}
                emptyClickedData={this.emptyClickedData}
                handleFeedbackResolve={this.handleFeedbackClick}
                feedbackData={this.props.feedBackData}
                createNewValidationFeedback={this.createNewValidationFeedback.bind(this)}
                activeValidationFeedbackSection={this.state.activeValidationFeedbackSection}
                activeValidationFeedbackData={this.state.activeValidationFeedbackData}
                handleAddCommentInFeedback={this.handleAddCommentInFeedback.bind(this)}
                allowFeedbacks={this.state.allowFeedbacks}
                studentInfo={this.state.studentInfo}
                remedialQuestion = {this.state.remedialQuestions}
                showRemedial={true}
                toggleViewRating={this.toggleViewRating.bind(this)}
                contentRatingInfo={this.state.contentRatingInfo}
                handleRateQuestionOpen={this.handleRateQuestionOpen.bind(this)}
              />
            );
          }
          case '7': {
            //Integer
            return (
              <MCQPreview
                questionBenchmarks={benchmarksData}
                content={content}
                openFeedback={openFeedback}
                authorType={this.getAuthorType()}
                contentRequestId={this.getContentRequestId()}
                contentRequestItemId={this.getContentRequestItemsId()}
                clickedfeedbackData={clickedfeedbackData}
                closeFeedback={this.closeFeedback}
                emptyClickedData={this.emptyClickedData}
                handleFeedbackResolve={this.handleFeedbackClick}
                feedbackData={this.props.feedBackData}
                createNewValidationFeedback={this.createNewValidationFeedback.bind(this)}
                activeValidationFeedbackSection={this.state.activeValidationFeedbackSection}
                activeValidationFeedbackData={this.state.activeValidationFeedbackData}
                handleAddCommentInFeedback={this.handleAddCommentInFeedback.bind(this)}
                allowFeedbacks={this.state.allowFeedbacks}
                studentInfo={this.state.studentInfo}
                remedialQuestion = {this.state.remedialQuestions}
                showRemedial={true}
                toggleViewRating={this.toggleViewRating.bind(this)}
                contentRatingInfo={this.state.contentRatingInfo}
                handleRateQuestionOpen={this.handleRateQuestionOpen.bind(this)}
              />
            );
          }
          case '8': {
            //MMCQ
            return (
              <MCQPreview
                questionBenchmarks={benchmarksData}
                content={content}
                openFeedback={openFeedback}
                authorType={this.getAuthorType()}
                contentRequestId={this.getContentRequestId()}
                contentRequestItemId={this.getContentRequestItemsId()}
                clickedfeedbackData={clickedfeedbackData}
                closeFeedback={this.closeFeedback}
                emptyClickedData={this.emptyClickedData}
                handleFeedbackResolve={this.handleFeedbackClick}
                feedbackData={this.props.feedBackData}
                createNewValidationFeedback={this.createNewValidationFeedback.bind(this)}
                activeValidationFeedbackSection={this.state.activeValidationFeedbackSection}
                activeValidationFeedbackData={this.state.activeValidationFeedbackData}
                handleAddCommentInFeedback={this.handleAddCommentInFeedback.bind(this)}
                allowFeedbacks={this.state.allowFeedbacks}
                studentInfo={this.state.studentInfo}
                remedialQuestion = {this.state.remedialQuestions}
                showRemedial={true}
                toggleViewRating={this.toggleViewRating.bind(this)}
                contentRatingInfo={this.state.contentRatingInfo}
                handleRateQuestionOpen={this.handleRateQuestionOpen.bind(this)}
              />
            );
          }
          default:
            return null;
        }
      }
      default:
        return null;
    }
  };

  handleCommentDialogClose() {
    const { id } = this.props.match.params;
    this.setState({ isCommentDialogOpen: false });
    this.props.getCommentCount(id);
  }

  handleEdit() {
    if (this.state.localIsPostExpiryDays) {
      this.props.toggleLicenseExpiredDialog(true);
    } else {
      const { content } = this.state;
      const { history, match } = this.props;
      const { contentTypeCode, contentSubTypeCode } = content;
      const {
        params: { requestId = '' },
      } = match;
      if (contentTypeCode === 'note') {
        history.push(`/content/edit/studymaterial/notes/${content._id}`);
      }
      if (contentTypeCode === 'studymaterial' && contentSubTypeCode === 'videos') {
        history.push(`/content/edit/studymaterial/videos/${content._id}`);
      }
      if (contentTypeCode === 'studymaterial' && contentSubTypeCode === 'audios') {
        history.push(`/content/edit/studymaterial/audios/${content._id}`);
      }
      if (requestId) {
        history.push(`/content/edit/${contentTypeCode}/${contentSubTypeCode}/${content._id}/${requestId}`);
      } else {
        const { fetchEditLockInfo } = this.props;
        const params = {
          _id: content._id,
        };
        const queryStrings = {
          eventType: 'edit',
        };

        const requestObject = {
          params,
          queryStrings,
        };
        fetchEditLockInfo(requestObject);
      }
    }
  }
  handleClick(direction: string) {
    if (direction === 'prev') {
      if (
        this.state.content.contentTypeCode === 'question' &&
        this.props.onContentChange &&
        this.props.currentQuestionNumber
      ) {
        let contentID = `${
          this.props.sliderData.contents[this.props.currentQuestionNumber - 2].content_id._id
        }question`;
        this.props.onContentChange(contentID, this.props.currentQuestionNumber - 1, 'question', 'preview');
      } else if (
        this.state.content.contentTypeCode === 'testpapers' &&
        this.props.onContentChange &&
        this.props.currentTestNumber
      ) {
        let contentID = `${this.props.sliderData.contents[this.props.currentTestNumber - 2].content_id._id}testpapers`;
        this.props.onContentChange(contentID, this.props.currentTestNumber - 1, 'test', 'preview');
      }
    } else {
      if (
        this.state.content.contentTypeCode === 'question' &&
        this.props.onContentChange &&
        this.props.currentQuestionNumber
      ) {
        let contentID = `${this.props.sliderData.contents[this.props.currentQuestionNumber].content_id._id}question`;
        this.props.onContentChange(contentID, this.props.currentQuestionNumber + 1, 'question', 'preview');
      } else if (
        this.state.content.contentTypeCode === 'testpapers' &&
        this.props.onContentChange &&
        this.props.currentTestNumber
      ) {
        let contentID = `${this.props.sliderData.contents[this.props.currentTestNumber].content_id._id}testpapers`;
        this.props.onContentChange(contentID, this.props.currentTestNumber + 1, 'test', 'preview');
      }
    }
    this.closeFeedback('resolve');
  }
  handleFeedbackEdit() {
    this.props.handleEditFromFeedback(this.state.content);
    this.setState({
      showAssignTest: false,
    });
  }
  handleClose = () => {
    const { history } = this.props;
    this.setState({
      isOpen: false,
    });
    history.push('/');
  };

  handleAddBenchMark() {
    const { content } = this.state;
    this.props.fetchGoalLevels({
      params: {
        courseTypeId:
          content.content.courseId &&
          content.content.courseId[0] &&
          content.content.courseId[0].courseType &&
          content.content.courseId[0].courseType.id,
      },
    });
    this.setState({ isOpenBenchmarkDialog: true });
  }

  handleFeedbackClick(clickedfeedbackData: any) {
    this.setState(
      {
        clickedfeedbackData: clickedfeedbackData,
        openFeedback: true,
      },
      () => {
        setTimeout(() => {
          if (document.getElementById('feedbackScroll') !== null) {
            // @ts-ignore
            document.getElementById('feedbackScroll').scrollIntoView(true);
          }
        }, 200);
      }
    );
  }

  loadMoreFeedback(pageNumber: number) {
    if (this.state.content && this.state.content.contentTypeCode === 'question') {
      if (this.state.content.contentSubTypeCode === QUESTION_TYPES.PARAGRAPH.toString()) {
        let resultIds = this.state.content.content.content.map((data: any) => data.paragraphQuestionId);
        resultIds = resultIds.join(',');
        this.props.getFeedback(this.getContentRequestId(), resultIds, 1);
      } else {
        this.props.getFeedback(this.getContentRequestId(), this.state.content.content._id, pageNumber);
      }
    } else {
      this.props.getFeedback(this.getContentRequestId(), this.state.content.content._id, pageNumber);
    }
  }

  acceptChallengeHandler = () => {
    this.props.setRequiresForceSaveForChallenge(true);
    this.handleEdit();
  };
  getButtonText(contentType: string) {
    let { sliderData, currentTestNumber, currentQuestionNumber, authorType } = this.props;
    let contentTypeCondition: any = contentType === 'testpapers' ? currentTestNumber : currentQuestionNumber;
    if (
      sliderData &&
      sliderData.contents &&
      sliderData.contents.length > 1 &&
      contentTypeCondition < sliderData.contents.length
    ) {
      return 'Verify and Next';
    } else {
      return 'Verify and Proceed';
    }
  }

  checkDisabledConditionForNext() {
    return this.props.feedBackData && this.props.feedBackData.pendingFeedbacksCount !== 0;
  }

  submitForVerify = async (
    contentRequestId: any,
    role: string,
    contentType: string,
    contentRequestItemId: string,
    content_id: string
  ) => {
    try {
      let { sliderData, currentTestNumber, currentQuestionNumber } = this.props;
      let contentTypeCondition: any = contentType === 'testpapers' || contentType === 'test' ? currentTestNumber : currentQuestionNumber;
      if (this.props.authorType !== 'creator') {
        await contentRequestServices.verifyAndNextRequest({
          contentRequestId: contentRequestId,
          role: role,
          contentType: contentType === 'testpapers' ? "test" : contentType,
          contentRequestItemId: contentRequestItemId,
          content_id: content_id,
        });
      }
      if (
        sliderData &&
        sliderData.contents &&
        sliderData.contents.length > 1 &&
        contentTypeCondition < sliderData.contents.length
      ) {
        this.handleClick('next');
      } else {
        if (this.props.closeReviewContainer) {
          this.props.closeReviewContainer();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  createNewValidationFeedback = (section: string, feedbackIndex: number = -1, feedbackData: any = {}) => {
    if (feedbackIndex !== -1) {
      feedbackData = this.state.validationFeedbacks[feedbackIndex];
    }
    this.setState({
      activeValidationFeedbackSection: section,
      activeValidationFeedbackIndex: feedbackIndex,
      activeValidationFeedbackData: feedbackData,
    });
  }

  handleAddCommentInFeedback = (comment: string, questionData: any = {}, editLast: boolean = false, isDeleteLast = false) => {
    if (!this.state.allowFeedbacks) {
      return;
    }
    if (isDeleteLast) {
      const {validationFeedbacks, newFeedbacks, activeValidationFeedbackIndex} = this.state;
      const feedbackId = (activeValidationFeedbackIndex && validationFeedbacks[activeValidationFeedbackIndex]._id);
      const feedbackPayloadInd = ((newFeedbacks || []).findIndex((feedback: any) => feedback.feedbackId === feedbackId) || {});
      (newFeedbacks || []).splice(feedbackPayloadInd, 1);
      validationFeedbacks[activeValidationFeedbackIndex].actions.pop();
      if(!validationFeedbacks[activeValidationFeedbackIndex].actions.length) {
        validationFeedbacks.splice(activeValidationFeedbackIndex, 1);
      }
      this.setState({
        validationFeedbacks: validationFeedbacks,
        activeValidationFeedbackSection: '',
        activeValidationFeedbackIndex: -1,
        newFeedbacks: [...newFeedbacks],
        activeValidationFeedbackData: {},
      });
      return;
    }
    if(!Object.keys(questionData).length){
      const content = getPropertyValue(this.state.content, 'content', {});
      questionData = {
        contentId: content.contentId,
        contentSubType: content.questionType
      }
    }
    const userData = JSON.parse(localStorage.getItem('patmy') || '');
    const userId = _.get(userData, 'authenticatedUser._id', '');
    const { activeValidationFeedbackSection, activeValidationFeedbackIndex } = this.state;
    const currValidationFeedbacks = this.state.validationFeedbacks;
    const newActionObj = {
      comment,
      userId,
      "validatorAction": FEEDBACK_VALIDATOR_ACTIONS.REJECTED,
      "date": NEW_FEEDBACK_TIME_TO_SHOW,
    };
    let feedbackId = '';
    let { addedFeedbackIndex } = this.state;
    if (activeValidationFeedbackIndex !== -1) {
      feedbackId = currValidationFeedbacks[activeValidationFeedbackIndex]._id;
      if(editLast) {
        currValidationFeedbacks[activeValidationFeedbackIndex].actions.pop();
      }
      currValidationFeedbacks[activeValidationFeedbackIndex].actions.push(newActionObj); 
    } else {
      const feedbackObj = {
        "status" : "open",
        "actions" : [newActionObj],
        "_id" : ++addedFeedbackIndex,
        section: activeValidationFeedbackSection,
        ...questionData
      };
      currValidationFeedbacks.push(feedbackObj)
    }
    const newFeedbackPayload: any = {
      section: activeValidationFeedbackSection,
      comment,
      feedbackId: feedbackId || addedFeedbackIndex,
      actions: [],
      ...questionData
    };
    const newFeedbacks = this.state.newFeedbacks;
    if (activeValidationFeedbackIndex !== -1) {
      newFeedbackPayload.actions = [...currValidationFeedbacks[activeValidationFeedbackIndex].actions];
      newFeedbackPayload.actions.pop();
    }
    let updatedNewFeedbacks: any = [...newFeedbacks, newFeedbackPayload];
    if (editLast) {
      const editFeedback = newFeedbacks.find((feedback: any) => feedback.feedbackId === feedbackId);
      if (editFeedback) {
        editFeedback.comment = comment;
      }
      updatedNewFeedbacks = newFeedbacks;
    }
    this.setState((prevState) => ({
      validationFeedbacks: currValidationFeedbacks,
      activeValidationFeedbackSection: '',
      activeValidationFeedbackIndex: -1,
      newFeedbacks: updatedNewFeedbacks,
      activeValidationFeedbackData: {},
      addedFeedbackIndex,
    }));
  };

  handleValidatorAction = (actionType: string) => {
    const firstValidatorForStudent = this.state.studentContent;
    if (firstValidatorForStudent && actionType === FEEDBACK_VALIDATOR_ACTIONS.APPROVED) {
      this.props.setValidatorFields(firstValidatorForStudent);
      return;
    }
    if (this.state.validatorNumber !== 3) {
      this.handleValidatorSubmit(actionType);
      return;
    }
    this.setState({
      confirmationDialogType: actionType,
      enableValidationConfirm: false,
    });
  };

  setValidatorMandatoryFields = (validatorMandatoryFields: boolean) =>
    this.setState({ validatorMandatoryFields })  

  submitValidatorField = async () => {
    const res = await getPropertyValue(this.state.submitValidatorRef, 'current', () => { })();
    if (res && res.statusCode === 200) {
      this.handleValidatorSubmit(FEEDBACK_VALIDATOR_ACTIONS.APPROVED);
    }
  }

  handleFeedbackEditMode = (allowFeedbacks: boolean) => {
    this.setState({
      allowFeedbacks,
      activeFeedbackSection: allowFeedbacks ? SIDEBAR_TAB.FEEDBACK : this.state.activeFeedbackSection
    });
  };

  handleRemoveFeedback = () => {
    this.toggleCancelButtonForFeedback();
    this.handleFeedbackEditMode(false);

    this.setState({
      activeValidationFeedbackSection: '',
      activeValidationFeedbackIndex: -1,
      activeValidationFeedbackData: {},
      validationFeedbacks: createDeepCopy(this.state.contentValidationFeedback),
      newFeedbacks: [],
      allowFeedbacks: false,
    });

  }

  handleValidatorSubmit = (actionType: string) => {
    const { validatorNumber, contentRatingInfo } = this.state;
    if (validatorNumber && validatorNumber > 1 && !(contentRatingInfo || {}).totalNoOfRatings && actionType !== FEEDBACK_VALIDATOR_ACTIONS.REJECTED) {
      this.setState({ validtorActionType: actionType }, () => {
        this.submitValidatorAction({});
      });
      return;
    }
    if(actionType ===  FEEDBACK_VALIDATOR_ACTIONS.APPROVED) {
      this.setState({validtorActionType: actionType, isRateQuestionModalOpen: true, isValidatorRating: true});
    } else {
      contentRatingServices.getRejectionCategories().then((res: any) => {
        this.setState({
          validtorActionType: actionType,
          questionRejectionReasons: res.responseObject.rejectionCategories,
          isRejectionReasonModalOpen: true,
        })
      })
    }
  };

  submitValidatorAction = (contentFeedback: any = {}) => {
    const { id = '' } = this.props.match.params;
    const {validtorActionType, existingValidationFeedbackIds} = this.state;
    const feedbacks = this.state.newFeedbacks;
    feedbacks.forEach((feedback: any) => {
      if(!existingValidationFeedbackIds.includes(feedback.feedbackId)) {
        feedback.feedbackId = '';  
      }
    })
    const payload: any = {
      contentId: id.substring(0, 24),
      actionType: validtorActionType,
      feedbacks,
    };
    if (Object.keys(contentFeedback).length) {
      if (validtorActionType === FEEDBACK_VALIDATOR_ACTIONS.APPROVED) {
        payload.rating = contentFeedback;
      } else {
        payload.rejectionReasons = contentFeedback.rejectionReasons;
        payload.rejectionComment = contentFeedback.rejectionComment;
      }
    }
    contentRequestServices.submitValidatorAction(payload).then((res: any) => {
      if(!res){
        return 
      }

      const { isPublished } = res;
      const { validatorNumber } = this.state;
      let bodyText = "";
      if (validtorActionType === FEEDBACK_VALIDATOR_ACTIONS.REJECTED) {
        bodyText = SUBMIT_MODAL_BODY_TEXT.REJECTED;
      } else if (isPublished) {
        bodyText = SUBMIT_MODAL_BODY_TEXT.SECOND_APPROVAL;
      } else if (validatorNumber === 1) {
        bodyText = SUBMIT_MODAL_BODY_TEXT.FIRST_APPROVAL;
      } else {
        bodyText = SUBMIT_MODAL_BODY_TEXT.FIRST_APPROVAL_WITH_CONFLICT;
      }
      this.setState({
        validationSubmitModalBody: bodyText,
        confirmationDialogType: ''
      });
    });
  }

  startNewValidation = (type: any) => {
    contentRequestServices.startNewValidation(type.value).then((res: any) => {
        const { contentId, contentType } = res;
        if(contentId && contentType){
          window.open('/content/preview/' + contentId + contentType);
        } else {
          this.props.showMsg('There are no questions in the validation pool available for you. Please try after sometime', VARIANT.WARNING);
        }
    });
  };

  handleRateQuestionClose = () => {
    this.setState({isRateQuestionModalOpen: false});
  }
  handleRateQuestionOpen = () => {
    this.setState({isRateQuestionModalOpen: true});
  }

  handleRejectionReasonModalClose = () => {
    this.setState({isRejectionReasonModalOpen: false});
  }

  toggleViewRating = () => {
    const {isViewRatingAndReviewOpen} = this.state;
    this.setState({isViewRatingAndReviewOpen: !isViewRatingAndReviewOpen});
  }

  onContentRatingSubmit = (rating: any) => {
    const { isValidatorRating } = this.state;
    if (isValidatorRating) {
      this.submitValidatorAction(rating);
      this.setState({ isRateQuestionModalOpen: false });
      return;
    }
    const payload = { rating, contentType: AUTHORING_CONTENT_TYPES.GLORIFIRE_QUESTION };
    const masterId = this.state.content.content_Id
    contentRatingServices.submitContentRating(masterId, payload).then((res: any) => {
      if (res.statusCode === STATUS_CODES.SUCCESS) {
        this.getContentRatingInfo(masterId)
        this.setState({ isRateQuestionModalOpen: false });
      }
    });
  }

  onContentRejectionSubmit = (rejectionFeedback: any) => {
    this.submitValidatorAction(rejectionFeedback);
    this.setState({isRejectionReasonModalOpen: false})
  }

  render() {
    const {
      classes,
      commentCount,
      lockData,
      updateBenchMarkInfo,
      authUser,
      sliderData,
      currentTestNumber,
      currentQuestionNumber,
      feedBackData,
      contentRequestId,
      authorType,
      validatorFields
    } = this.props;
    const { message } = lockData;
    const {
      content,
      isDeleteDialogOpen,
      isShareDialogOpen,
      isCommentDialogOpen,
      latexLoad,
      isOpen,
      contentHistory,
      questionAnalytics,
      testAnalytics,
      validationFeedbacks,
      validationEditHistory,
      confirmationDialogType,
      allowFeedbacks,
      newFeedbacks,
      enableValidationConfirm,
      validationStatus,
      validatorNumber,
      validationSubmitModalBody,
      submitValidatorRef,
      validatorMandatoryFields,
      activeFeedbackSection,
      isRateQuestionModalOpen,
      isRejectionReasonModalOpen,
      isViewRatingAndReviewOpen,
      questionRejectionReasons,
      contentRatingInfo,
      isValidatorRating,
    } = this.state;
    const creatorId = _.get(content, 'content.aclMetaData.createdBy.id');
    const isCreatedByLoggedInUser = creatorId && authUser && creatorId === authUser._id;
    const questionId = _.get(content, 'content._id');
    const referrer = document.referrer;
    let redirect: any = '/';

    if (referrer.includes('contentRequest/owner-task')) {
      let dataA = referrer.split('contentRequest/owner-task')[1];
      redirect = `/contentRequest/owner-task${dataA}`;
    }
    const isDuplicationPermitted = this.isDuplicationPermitted(content.contentTypeCode);
    const showSidebarMenuOptions = content.contentTypeCode !== CONTENT_TYPE.QUESTION || (content.status === CONTENT_STATES.PUBLISHED) || (content.contentTypeCode === CONTENT_TYPE.QUESTION && content.status !== CONTENT_STATES.DRAFT && !validatorNumber);
    const isTeacher = checkForTeacherUser(this.state.content);
    const validationLength =(validationFeedbacks || []).length;
    const contentStatusTitle = titleCase(content.contentTypeCode);
    const isAuthor = checkForAuthor(this.state.content);
    return (
      <>
        <Grid className={classes.toolBox}>
          {!this.props.fromFeedback ? (
            <Grid container alignItems='center' justify='space-between'>
              <Grid item>
                {/* this.props.history.goBack() */}
                {validatorFields ?
                  <div onClick={() => this.props.setValidatorFields(false)} className={'closeButton '+classes.backValidatorButton}>
                    <ChevronLeftIcon>chevron_left</ChevronLeftIcon>
                    Back
                  </div>
               : <MyPATLink
                  //onClick={() => false}
                  to={redirect}
                  className={classes.backButton}
                >
                  <ChevronLeftIcon>chevron_left</ChevronLeftIcon> Back
                </MyPATLink>
                  }
              </Grid>
              
              <Grid item className={classes.actionContainer}>
                {/* )} */}
                {/* <IconButton
                  className={classes.commentButton}
                  onClick={() => this.setState({ isCommentDialogOpen: true })}
                >
                  <Badge badgeContent={commentCount} color="secondary">
                    <img src="/assets/img/mylibrary/big-speech-balloon.png" />
                  </Badge> // Just commented for later Use
                </IconButton> */}
                {
                  (content.status === CONTENT_STATES.PUBLISHED || !isTeacher) && (<>
                {content.contentTypeCode === CONTENT_TYPE.QUESTION && <Button
                  disabled={
                    !(
                      isDuplicationPermitted
                    )
                  }
                  className={[classes.copyButton, classes.blue].join(' ')}
                  variant='outlined'
                  onClick={this.createClone}
                >
                  {!(
                    isDuplicationPermitted
                  ) ? (
                    <img className='disabled' src='/assets/svg/createContent/duplicate.svg' />
                  ) : (
                    <img src='/assets/svg/createContent/duplicate-blue.svg' />
                  )}
                  Duplicate
                </Button>}
                {/* <Button
                  className={`${[classes.shareButton, classes.blue].join(' ')} ${
                    !ACLService.checkModulePermission('share', 'allow') ? classes.hide : ''
                  }`}
                  variant='outlined'
                  onClick={this.shareClick}
                >
                  <img src='/assets/svg/share-icon.svg' /> Share
                </Button> */}
                </>)
                }
                {
                  (!isTeacher || (isCreatedByLoggedInUser && (!validationStatus || [FEEDBACK_VALIDATOR_ACTIONS.REJECTED, FEEDBACK_VALIDATOR_ACTIONS.PUBLISHED].includes(validationStatus))))
                  && this.checkEditPermission() &&
                  <div className={classes.editButton}>
                    <Button
                      variant='contained'
                      color='primary'
                      onClick={this.handleEdit}
                      disabled={this.checkContentRequest() || this.isContentInDraft()}
                    >
                      Edit
                    </Button>
                    {this.isContentInDraft() && (
                      <div className="tooltip">
                        {((content.draftData || {}).validationStatus === FEEDBACK_VALIDATOR_ACTIONS.QUEUED) ?
                          'Editing of this question is not allowed as it is currently in the queue for test result regeneration' :
                          'Editing of this question is not allowed as another linked copy of it is presently under In Review status'
                        }
                      </div>
                    )}
                  </div>
                }
              </Grid>
            </Grid>
          ) : (
            <Grid container alignItems='center' spacing={16} className={classes.feedbackTopNav}>
              <Grid item xs={4} onClick={() => this.props.setFeedbackClose({ booleanValue: true })}>
  
                 <MyPATLink to={this.props.prevPath} className='closeButton'>
                  <ChevronLeftIcon>chevron_left</ChevronLeftIcon>
                  &nbsp;Back 
                </MyPATLink>        
              </Grid>
              <Grid item xs={8}>
                <Grid>
                  {this.props.fromFeedback && (
                    <Grid container className='feedbackAction' justify='flex-end' alignItems='center' spacing={16}>
                      <Grid item>
                        <Button
                          variant='contained'
                          color='primary'
                          onClick={() => this.handleFeedbackEdit()}
                          disabled={!this.checkEditPermission()}
                        >
                          Edit
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          variant='outlined'
                          color='primary'
                          onClick={() => this.handleFeedback()}
                          disabled={!ACLService.checkModulePermission(content.contentTypeCode, 'validate')}
                        >
                          <img src='/assets/svg/contentRequest/feedback-trans.svg' alt='feedback' />
                          &nbsp;<span>Add Feedback</span>
                        </Button>
                        <CustomInfoIcon
                          infoDialogContentType='Add Feedback'
                          isCenterArrow={true}
                          isLeftArrow={false}
                          isRightArrow={false}
                          isInfoIcon={true}
                          knowMoreAbout={false}
                          dialogTitle='Add Feedback'
                          imageURL='/assets/svg/contentRequest/feedbackIcon.svg'
                          dialogPara='After clicking over this button, you can add feedback over each section of the question. You can click over headings to seek space for adding feedback.'
                          details='Click to know more'
                          toolTipDirection='top'
                        />
                      </Grid>
                    </Grid>
                  )}
                </Grid>
                {/* {content.contentTypeCode !== "testpapers" && (
                  <>
                    <span>
                      {currentQuestionNumber}/
                      {sliderData &&
                        sliderData.contents &&
                        sliderData.contents.length}{" "}
                      Question
                    </span>
                    <span
                      onClick={() => this.handleClick("prev")}
                      className={
                        currentQuestionNumber === 1
                          ? [classes.deactiveArrow, "arrow"].join(" ")
                          : [classes.activeArrow, "arrow"].join(" ")
                      }
                    >
                      <ChevronLeftIcon />
                    </span>
                    <span
                      onClick={() => this.handleClick("next")}
                      className={
                        currentQuestionNumber ===
                        (sliderData &&
                          sliderData.contents &&
                          sliderData.contents.length)
                          ? [classes.deactiveArrow, "arrow"].join(" ")
                          : [classes.activeArrow, "arrow"].join(" ")
                      }
                    >
                      <ChevronRightIcon />
                    </span>
                  </>
                )}
                {content.contentTypeCode === "testpapers" && (
                  <>
                    <span>
                      {currentTestNumber}/
                      {sliderData &&
                        sliderData.contents &&
                        sliderData.contents.length}{" "}
                      Test
                    </span>
                    <span
                      onClick={() => this.handleClick("prev")}
                      className={
                        currentTestNumber === 1
                          ? [classes.deactiveArrow, "arrow"].join(" ")
                          : [classes.activeArrow, "arrow"].join(" ")
                      }
                    >
                      <ChevronLeftIcon />
                    </span>
                    <span
                      onClick={() => this.handleClick("next")}
                      className={
                        currentTestNumber ===
                        (sliderData &&
                          sliderData.contents &&
                          sliderData.contents.length)
                          ? [classes.deactiveArrow, "arrow"].join(" ")
                          : [classes.activeArrow, "arrow"].join(" ")
                      }
                    >
                      <ChevronRightIcon />
                    </span>
                  </>
                )} */}
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid className={classes.paddingBot50} container spacing={24}>
          <Grid item xs={2} />
          <Grid item xs={7}>
            <div
              style={{
                // marginTop: "16px",
                width: '100%',
                wordBreak: 'break-word',
                marginTop: '15px',
              }}
            >
              {latexLoad && (validatorFields ? <ValidatorFields contentData={content} submitValidatorRef={submitValidatorRef} setValidatorMandatoryFields={this.setValidatorMandatoryFields} /> : 
                <div className={classes.previewContainer}>{this.previewComponent()}</div>)}
            </div>
          </Grid>

          <Grid item xs={3} className={classes.sidePanel}>
            {/* {this.isFromContentRequest() && (
              <Grid
                container
                className="feedbackAction"
                justify="flex-end"
                alignItems="center"
                spacing={16}
              >
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.handleFeedbackEdit()}
                    disabled={!this.checkEditPermission()}
                  >
                    Edit
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => this.handleFeedback()}
                    disabled={
                      !ACLService.checkModulePermission(
                        content.contentTypeCode,
                        "validate"
                      )
                    }
                  >
                    <img
                      src="/assets/svg/contentRequest/feedback-trans.svg"
                      alt="feedback"
                    />
                    &nbsp;<span>Add Feedback</span>
                  </Button>
                </Grid>
              </Grid> */}
            {/* )} */}
            <MyPATCollapseSection activeSectionKey={activeFeedbackSection}>
              {
                <MyPATCollapseSectionItem
                sectionKey='previewPageInfo'
                sectionName='Page Info'
                icon='/assets/svg/new-info.svg'
              >
                <PreviewPageInfo
                  content={content}
                  deleteContent={this.deleteContent}
                  contentHistory={contentHistory}
                  contentRequestIds={this.state.contentRequestIds}
                  showAssignTest={this.state.showAssignTest}
                />
              </MyPATCollapseSectionItem>
              }
              {(!this.props.fromFeedback && showSidebarMenuOptions) && (
                <MyPATCollapseSectionItem
                  sectionKey='sharedWithContent'
                  sectionName={`Shared With (${_.get(content, 'aclMetaData.allowedTo', []).length})`}
                  icon='/assets/svg/shared.svg'
                >
                  <SharedContentWith content={content} />
                </MyPATCollapseSectionItem>
              )}

              {content.contentTypeCode === 'testpapers' && (
                <MyPATCollapseSectionItem
                  sectionKey='benchmarks'
                  sectionName='Benchmarks'
                  icon='/assets/svg/benchmark.svg'
                >
                  <Benchmark
                    content={content}
                    isOpen={this.state.isOpenBenchmarkDialog}
                    onClose={() => this.setState({ isOpenBenchmarkDialog: false })}
                    onAdd={this.handleAddBenchMark.bind(this)}
                    onUpdate={(data: any) => updateBenchMarkInfo({ payload: data })}
                    onUpdateComplete={() => this.setState({ isOpenBenchmarkDialog: false })}
                  />
                </MyPATCollapseSectionItem>
              )}

              {
                showSidebarMenuOptions && (
              <MyPATCollapseSectionItem
                sectionKey='otherRelatedContent'
                sectionName='Other Related Content'
                icon='/assets/svg/related.svg'
              >
                <OtherRelatedContent content={content} />
              </MyPATCollapseSectionItem>
                )
              }
              {(content.contentTypeCode == 'question' && showSidebarMenuOptions) && (
                <MyPATCollapseSectionItem
                  sectionKey='questionAnalytics'
                  sectionName='Question Analytics'
                  icon='/assets/svg/analytics.svg'
                >
                  <QuestionAnalytics content={questionAnalytics} />
                </MyPATCollapseSectionItem>
              )}
              {content.contentTypeCode === 'question' && showSidebarMenuOptions && !this.props.fromFeedback && (
                <MyPATCollapseSectionItem
                  sectionKey='challengeQuestion'
                  sectionName='Challenge Question'
                  icon='/assets/svg/challenge-icon.svg'
                >
                  <ChallengeQuestion
                    acceptChallengeHandler={this.acceptChallengeHandler}
                    isCreatedByLoggedInUser={isCreatedByLoggedInUser}
                    questionId={questionId}
                    authUser={authUser}
                    questionDetails={this.props.match.params.id}
                  />
                </MyPATCollapseSectionItem>
              )}
              {this.isFromContentRequest() && showSidebarMenuOptions && (
                <MyPATCollapseSectionItem
                  sectionKey='feedback'
                  count={feedBackData && feedBackData.totalCount}
                  sectionName={
                    <>
                      Feedback ({feedBackData && feedBackData.totalCount})
                      <CustomInfoIcon
                        infoDialogContentType='Feedback'
                        isInfoIcon={true}
                        isRightArrow={false}
                        isCenterArrow={true}
                        knowMoreAbout={false}
                        dialogTitle='Feedback'
                        imageURL='/assets/svg/contentRequest/feedbackIcon.svg'
                        dialogPara='In this panel you can see all the feedbacks given by the authors working on the associated request. After clicking over the feedback, you will redirected to the specific heading where you can find responses to the feedback and perform action like reply or resolve'
                        details='Click to know more'
                        toolTipDirection='top'
                      />
                    </>
                  }
                  icon='/assets/svg/feedback-icon.svg'
                >
                  <FeedbackPreview
                    feedBackData={feedBackData}
                    handleFeedbackResolve={this.handleFeedbackClick}
                    loadMoreFeedback={this.loadMoreFeedback}
                  />
                </MyPATCollapseSectionItem>
              )}
              {content.contentTypeCode == 'testpapers' && (
                <MyPATCollapseSectionItem
                  sectionKey='testAnalytics'
                  sectionName='Test Analytics'
                  icon='/assets/svg/analytics.svg'
                >
                  <TestAnalytics content={testAnalytics} />
                </MyPATCollapseSectionItem>
              )}
              {content.contentTypeCode === 'testpapers' && (
                <MyPATCollapseSectionItem
                  sectionKey='PreviewTest'
                  sectionName='Preview Test'
                  icon='/assets/svg/preview-test.svg'
                >
                  <PreviewTest testId={this.state.testId} content={this.state.content}/>
                </MyPATCollapseSectionItem>
              )}
               {content.contentTypeCode !== 'testpapers' && showSidebarMenuOptions && (
                    <MyPATCollapseSectionItem
                    sectionKey="suggestions"
                    sectionName="Duplicate and Similar"
                    icon="/assets/svg/duplicateSimilarIcon.svg"
                  >
                    <ContentSuggestions
                      contentType={content.contentTypeCode}
                      contentId={content.content_Id}
                    />
                  </MyPATCollapseSectionItem>
              )}

              {
                isAuthor ? (validationLength ? (validationFeedbacks && allowFeedbacks) : allowFeedbacks)
                 : ((validationFeedbacks && [FEEDBACK_VALIDATOR_ACTIONS.NO_ACTION, FEEDBACK_VALIDATOR_ACTIONS.IN_REVIEW].includes(validationStatus)
                 ? allowFeedbacks : (validationFeedbacks || allowFeedbacks)) && (
                  <MyPATCollapseSectionItem
                    sectionKey='feedbackSec'
                    sectionName={`Feedback (${validationLength})`}
                    count={validationFeedbacks.length}
                    icon='/assets/svg/feedback-icon.svg'
                    hideCloseButton={this.state.allowFeedbacks}
                  >
                    <FeedbackSidebar
                      createNewValidationFeedback={this.createNewValidationFeedback.bind(this)}
                      validationFeedbacks={validationFeedbacks}
                      allowFeedbacks={allowFeedbacks}
                      selectedQuestionRef={this.state.currentSelectedQuestionRef}
                      contentType={content.contentTypeCode}
                      validationEditHistory={validationEditHistory}
                    />
                  </MyPATCollapseSectionItem>
                ))
              }

              { validationEditHistory.length && this.state.showEditHistory &&
              <MyPATCollapseSectionItem
                sectionKey='historySec'
                sectionName={`${titleCase(content.contentTypeCode)} History`}
                icon='/assets/svg/history-icon.svg'
              >
                <ContentValidationEditHistory
                  editHistory={validationEditHistory}
                  createNewValidationFeedback={this.createNewValidationFeedback.bind(this)}
                  selectedQuestionRef={this.state.currentSelectedQuestionRef}
                />
              </MyPATCollapseSectionItem>
             }
            </MyPATCollapseSection>
            <ContentDeleteConfirm
              isDeleteDialogOpen={isDeleteDialogOpen}
              contentList={[content]}
              onDeleteConfirmed={this.onDeleteConfirmed}
            />
            {isShareDialogOpen && (
              <ContentShareModal contentList={[content]} isShareDialogOpen={isShareDialogOpen} onShared={this.onShared} />
            )}
          </Grid>
        </Grid>
        {isCommentDialogOpen && (
          <CommentDialog
            isDialogOpen={isCommentDialogOpen}
            content={content}
            dialogCloseHandler={this.handleCommentDialogClose.bind(this)}
          />
        )}

        {isOpen ? (
          <ModalComponent
            component={() => (
              <>
                <MuiDialogContent className={classes.paddingSet}>
                  <div className={classes.popupBlock}>
                    <b className={classes.attentionTitle}>Attention</b>
                    <img
                      src='https://mypat-v2-prod.s3-us-west-2.amazonaws.com/webcontent/cms/attention.png'
                      alt='Attention'
                    />
                    <p>{message}</p>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <Button autoFocus variant='contained' color='primary' onClick={this.handleClose}>
                      OK
                    </Button>
                  </div>
                </MuiDialogContent>
                <MuiDialogActions />
              </>
            )}
          />
        ) : (
          ''
        )}
        {this.props.fromFeedback && (
          <Grid container justify='space-between' className={classes.footerFixed}>
            <Grid item>
              <Grid className={classes.displayFlex}>
                {content.contentTypeCode !== 'testpapers' && (
                  <>
                    <span>
                      {currentQuestionNumber}/{sliderData && sliderData.contents && sliderData.contents.length} Question
                    </span>
                    <span
                      onClick={() => this.handleClick('prev')}
                      className={
                        currentQuestionNumber === 1
                          ? [classes.deactiveArrow, 'arrow'].join(' ')
                          : [classes.activeArrow, 'arrow'].join(' ')
                      }
                    >
                      <ChevronLeftIcon />
                    </span>
                    <span
                      onClick={() => this.handleClick('next')}
                      className={
                        currentQuestionNumber === (sliderData && sliderData.contents && sliderData.contents.length)
                          ? [classes.deactiveArrow, 'arrow'].join(' ')
                          : [classes.activeArrow, 'arrow'].join(' ')
                      }
                    >
                      <ChevronRightIcon />
                    </span>
                  </>
                )}
                {content.contentTypeCode === 'testpapers' && (
                  <>
                    <span>
                      {currentTestNumber}/{sliderData && sliderData.contents && sliderData.contents.length} Test
                    </span>
                    <span
                      onClick={() => this.handleClick('prev')}
                      className={
                        currentTestNumber === 1
                          ? [classes.deactiveArrow, 'arrow'].join(' ')
                          : [classes.activeArrow, 'arrow'].join(' ')
                      }
                    >
                      <ChevronLeftIcon />
                    </span>
                    <span
                      onClick={() => this.handleClick('next')}
                      className={
                        currentTestNumber === (sliderData && sliderData.contents && sliderData.contents.length)
                          ? [classes.deactiveArrow, 'arrow'].join(' ')
                          : [classes.activeArrow, 'arrow'].join(' ')
                      }
                    >
                      <ChevronRightIcon />
                    </span>
                  </>
                )}
              </Grid>
            </Grid>
            <Grid item>
              {this.props.authorType !== 'creator' && (
                <Button
                  variant='contained'
                  color='primary'
                  className='fullButton'
                  disabled={this.checkDisabledConditionForNext()}
                  onClick={() =>
                    this.submitForVerify(
                      this.getContentRequestId(),
                      authorType,
                      content.contentTypeCode,
                      sliderData && sliderData._id,
                      content.content_Id
                    )
                  }
                >
                  {this.getButtonText(content.contentTypeCode)}
                </Button>
              )}
            </Grid>
          </Grid>
        )}

        {
          validatorNumber && [FEEDBACK_VALIDATOR_ACTIONS.NO_ACTION, FEEDBACK_VALIDATOR_ACTIONS.IN_REVIEW].includes(validationStatus) &&
          <Grid className={classes.contentValidationFooter}>
              <p className='instruction'>{allowFeedbacks ? FOOTER_TEXT.VALIDATING : FOOTER_TEXT.VALIDATOR}</p>
            <div className='btnGroupContainer'>
              {
                !allowFeedbacks ?
                <>
                  <button className='btnBorder' onClick={()=>this.handleFeedbackEditMode(true)}>Reject {contentStatusTitle}</button>
                  <button className='btnFill' onClick={()=>this.handleValidatorAction(FEEDBACK_VALIDATOR_ACTIONS.APPROVED)}>Approve {contentStatusTitle}</button>
                </>
                : <>
                  <Button color="primary" className='btnText' onClick={this.toggleCancelButtonForFeedback}>Cancel</Button>
                  <button className='btnFill' disabled={!newFeedbacks.length} onClick={()=>this.handleValidatorAction(FEEDBACK_VALIDATOR_ACTIONS.REJECTED)}>Reject</button>
                </>
              }
            </div>
          </Grid>
        }
        {
          validatorFields  &&
          <Grid className={classes.contentValidationFooter}>
            <div className='btnGroupContainer'>
              <button className='btnFill' disabled={!validatorMandatoryFields} onClick={this.submitValidatorField}>Approve</button>
            </div>
          </Grid>
        }

        <MyPATDialog
          classes={{root: classes.confirmationDialog}}
          dialogOpen={confirmationDialogType}
          onDialogClose={()=>this.handleValidatorAction('')}
          dialogHasActions={true}
          isOverflowVisible={true}
          isCloseButtonHidden={true}
          dialogHeading={
            <>
              <h6 className={classes.confirmationDialogTitle}>Confirmation</h6>
            </>
          }
          isAlignCenter={false}
          isCustomBackground={false}
          isborderDialogAction={false}
          otherDialogProps={{
            fullWidth: true,
            maxWidth: "sm",
            scroll: "body",
          }}
          customDialogActions={
            <>
              <Grid
                container
                justify="center"
                spacing={8}
                alignItems="center"
                className={classes.confirmationDialogButton}
              >
                <Grid item>
                  <Button color="primary" className='btnText' onClick={()=>this.handleValidatorAction('')}>Cancel</Button>
                </Grid>
                <Grid item>
                  <Button variant="contained" color="primary" disabled={!this.state.enableValidationConfirm} className='btnFill' onClick={()=>this.handleValidatorSubmit(confirmationDialogType)}>
                    Confirm
                  </Button>
                </Grid>
              </Grid>
            </>
          }
        >
          <Grid container justify="flex-start" spacing={24} className={classes.confirmationDialogPara}>
            <p>Are you sure that you want to { confirmationDialogType === FEEDBACK_VALIDATOR_ACTIONS.APPROVED ? 'approve' : 'reject' } this question ?</p>
            <div className='declationContent'>
              <p><strong>Declaration:</strong> I commit to resolving the disagreement between the two validators' decision by taking appropriate action on this question. I understand that my decision may result in penalisation of Validation Contribution for the incorrect decision taken by validators, and I acknowledge that I have thoroughly examined the question's comments and edit histories. I have carefully reviewed the created question and considered every scenario of the correct question to the best of my ability.</p>
            </div>
            <div className={classes.inputCheckbox}>
                <Checkbox classes={{checked:classes.checkboxChecked}} id='formInputCheckbox' onChange={()=>this.setState(prevState => ({enableValidationConfirm: !prevState.enableValidationConfirm}))} />
              <label htmlFor='formInputCheckbox'>I hereby declare that I have read the declaration carefully</label>
            </div>
          </Grid>
        </MyPATDialog>
        {
          validationSubmitModalBody && <ValidationSubmitModal bodyText={validationSubmitModalBody} startNewValidation={this.startNewValidation.bind(this)} />
        }
        <MyPATDialog
          dialogOpen={this.state.removeFeedbackForAuthor}
          onDialogClose={() => this.handleValidatorAction('')}
          dialogHasActions={true}
          isOverflowVisible={true}
          isCloseButtonHidden={true}
          dialogHeading={
            <>
              <h6 className={classes.confirmationDialogTitle}>Confirmation</h6>
            </>
          }
          fixedDialogActions
          isAlignCenter={true}
          isCustomBackground={false}
          isborderDialogAction={true}
          otherDialogProps={{
            fullWidth: true,
            maxWidth: "sm",
            scroll: "body",
          }}
          customDialogActions={
            <>
              <Grid
                container
                justify="center"
                spacing={8}
                alignItems="center"
                className={cx(classes.confirmationDialogButton, classes.confirmationDialogButtonPadding)}
              >
                <Grid item>
                  <Button color="primary" className='btnText' onClick={this.toggleCancelButtonForFeedback}>Cancel</Button>
                </Grid>
                <Grid item>
                  <Button variant="contained" color="primary" className='btnFill' onClick={this.handleRemoveFeedback}>
                    Yes, Proceed
                  </Button>
                </Grid>
              </Grid>
            </>
          }
        >
          <Grid container justify="flex-start" spacing={24} className={cx(classes.confirmationDialogPara, classes.confirmationParagraphMargin)}>
            <p>Are you sure you don't want to proceed with rejecting this question. Any feedback given will be lost.</p>
          </Grid>
        </MyPATDialog>
        <RateQuestionModal isRateQuestionModalOpen={isRateQuestionModalOpen} handleRateQuestionClose={this.handleRateQuestionClose} onContentRatingSubmit={this.onContentRatingSubmit.bind(this)} isValidatorRating={isValidatorRating} />
        <RejectionReasonModal isRejectionReasonModalOpen={isRejectionReasonModalOpen} handleRejectionReasonModalClose={this.handleRejectionReasonModalClose} questionRejectionReasons={questionRejectionReasons} onRejectionSubmit={this.onContentRejectionSubmit.bind(this)}/>
        {isViewRatingAndReviewOpen && <ViewRatingAndReview toggleViewRating={this.toggleViewRating.bind(this)} contentRatingInfo={contentRatingInfo} handleRateQuestionOpen={this.handleRateQuestionOpen.bind(this)} />}
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  commentList: _.get(state, 'mylibraryData.comment.list', []),
  commentCount: _.get(state, 'mylibraryData.comment.count', 0),
  lockData: _.get(state, 'mylibraryData.content.lockData', {}),
  userData: state.loginData.userData,
  loggedInUserData: state.loginData.userData && state.loginData.userData.loggedInUserData,
  showLicenseExpiredDialog: state.loginData.userData && state.loginData.userData.showLicenseExpiredDialog,
  isPostExpiryDays: state.loginData.userData && state.loginData.userData.isPostExpiryDays,
  authUser: _.get(state, 'loginData.userData.authenticatedUser'),
  feedBackData: state.contentRequestReducer.contentRequestReducer.feedBackData,
  refreshFeedback: state.contentRequestReducer.contentRequestReducer.refreshFeedback,
  suggestions:state.mylibraryData.content.contentSuggestions,
  validatorFields: state.questionCreate.validatorFields
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      getCommentCount,
      fetchEditLockInfo: contentActions.fetchEditLockInfo,
      fetchBenchMarkInfo: contentActions.fetchBenchMarkInfo,
      updateBenchMarkInfo: contentActions.updateBenchMarkInfo,
      fetchGoalLevels: contentActions.fetchGoalLevels,
      toggleLicenseExpiredDialog,
      setRequiresForceSaveForChallenge: contentActions.setRequiresForceSaveForChallenge,
      setLoggedInUser,
      getFeedback: getFeedback,
      setFeedbackClose: contentRequestAccordianActions.setFeedbackClose,
      setContentSuggestions: contentActions.setContentSuggestions,
      showAlert:showAlert,
      setSpecialPurposes: questionActions.setSpecialPurposes,
      showMsg: showMsg,
      setValidatorFields:questionActions.setValidatorFields
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(ContentPreview));